/* Plan helpers for the Find Candidates page (editor, running sheet, results recap).
   A brief's plan is three lists — positions, keywords, employers — beside its checklist (must-haves,
   nice-to-haves, exclusions). The live run opens with the first two positions (each with the first
   keyword) and hands the rest to the agent as context. Mirrors _normalize_brief in
   ai_db/services/renidly_pipeline.py. */

export const MAX_POSITIONS = 8;
export const MAX_KEYWORDS = 20;
export const MAX_EMPLOYERS = 20;

const list = (v) =>
  Array.isArray(v) ? v.map((x) => String(x).trim()).filter(Boolean) : [];

/** Cleaned phrases of 3+ characters, first spelling kept. */
function phrases(raw, cap, width) {
  const out = [];
  const seen = new Set();
  (Array.isArray(raw) ? raw : []).forEach((item) => {
    const t = String(item || "")
      .replace(/\s+/g, " ")
      .trim()
      .slice(0, width);
    if (t.length < 3 || seen.has(t.toLowerCase())) return;
    seen.add(t.toLowerCase());
    out.push(t);
  });
  return out.slice(0, cap);
}

/** The plan of a brief as the three lists every screen reads. */
export function planOf(brief) {
  return {
    positions: phrases(brief?.positions, MAX_POSITIONS, 100),
    keywords: phrases(brief?.keywords, MAX_KEYWORDS, 60),
    employers: list(brief?.employers).slice(0, MAX_EMPLOYERS),
  };
}

/* The plan and checklist as labelled chip rows for the results recap. */
export function briefFilterRows(brief, country = "") {
  if (!brief) return [];
  const plan = planOf(brief);
  const rows = [
    { label: "Positions", tone: "accent", now: plan.positions },
    { label: "Keywords", tone: "accent", now: plan.keywords },
    { label: "Employers", now: plan.employers.map((e) => `at ${e}`) },
    {
      label: "Location",
      now: list(brief.locations).length
        ? list(brief.locations)
        : String(country || "").split(",").map((c) => c.trim()).filter(Boolean),
    },
    { label: "Must-haves", tone: "success", now: list(brief.must_haves) },
    { label: "Nice-to-haves", now: list(brief.nice_to_haves) },
    { label: "Exclusions", tone: "danger", now: list(brief.exclusions) },
  ];
  return rows
    .map(({ label, tone, now }) => ({ label, tone, chips: now.map((t) => ({ text: t })) }))
    .filter((f) => f.chips.length > 0);
}
